// File: clientapp/src/pages/SecurityAdminLayout.js
import React from 'react';
import { Outlet, NavLink } from 'react-router-dom';
import { Box, List, ListItem, ListItemText, Typography, Paper } from '@mui/material';

export default function SecurityAdminLayout() {
    const menuItems = [
        { label: 'Users', path: 'users' },
        { label: 'Groups', path: 'groups' },
        { label: 'Roles', path: 'roles' },
        { label: 'Features', path: 'features' },
        { label: 'Settings', path: 'settings' } // New menu item for Settings
    ];

    return (
        <Box display="flex" minHeight="100vh">
            <Paper style={{ width: 240, padding: 16 }}>
                <Box display="flex" alignItems="center" mb={2}>
                    <Typography variant="h6" ml={1}>
                        Security Admin
                    </Typography>
                </Box>
                <List>
                    {menuItems.map((item) => (
                        <ListItem
                            button
                            key={item.path}
                            component={NavLink}
                            to={item.path}
                            style={({ isActive }) => ({
                                backgroundColor: isActive ? '#f5f5f5' : 'transparent'
                            })}
                        >
                            <ListItemText primary={item.label} />
                        </ListItem>
                    ))}
                </List>
            </Paper>
            <Box flex="1" padding={2}>
                <Outlet />
            </Box>
        </Box>
    );
}
